import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getTicketTypes = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/ticket-types/?limit=${limit}&offset=${offset}`
  );
  return response.data;

};

export const getTicketTypesByEvent = async (limit = 10, offset = 0, eventId) => {
  const response = await api.get(
    `api/v1/ticket-types/?event=${eventId}&limit=${limit}&offset=${offset}`
  );
  return response.data;
};

export const getAllTicketTypesByEvent = async (limit = 9999, offset = 0, eventId) => {
  const response = await api.get(
    `api/v1/ticket-types/?event=${eventId}&limit=${limit}&offset=${offset}`
  );
  return response.data;
};

export const createTicketTypes = async (payload) => {
  const response = await api.post(
    "api/v1/ticket-types/",
    payload
  );
  return response.data;
};

export const updateTicketType = async (ticketId, payload) => {
  const response = await api.patch(
    `api/v1/ticket-types/${ticketId}/`,
    payload
  );
  return response.data;
};


export const deleteTicketType = async (ticketId) => {
  await api.delete(`api/v1/ticket-types/${ticketId}/`);
};



